import { React, useState, useEffect, useRef } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import PDFConverterAppListView from "./PDFConverterAppListView";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function PDFConverterMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "PDF Converter Online Free" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_converter", title: "Convert PDF For Free" },
    data2: { link: "/pdf_to_image", title: "PDF To Image Converter" },
    data3: { link: "/image_to_pdf", title: "Image To PDF Converter" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        showEditFileScreen,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert PDF files online easily. Change PDF to Word, Excel, JPG, and more formats quickly with our fast, secure, and reliable PDF converter."
      ></meta>
      <meta
        name="keywords"
        content="pdf converter, convert pdf, pdf to word, pdf to excel, pdf to jpg, pdf to png, pdf to ppt, word to pdf, excel to pdf, image to pdf, online pdf converter, pdf file converter, free pdf converter, pdf conversion tool, secure pdf converter, pdf to docx online, pdf to doc online, pdf to odr online, doc to pdf online, docx to pdf online, ppt to pdf online, pdf to ppt online, pptx to pdf online, pdf to pptx online, xls to pdf online, xlsx to pdf online, pdf to xlsx online, pdf to xls online, free pdf converter, pdf converter for free, download pdf converter, docuemnt converter,"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* App List */}
        <PDFConverterAppListView />
        {/* Mid Section */}
        <MiscPageMidSection description="Our PDF Converter website offers a fast, secure, and reliable solution for converting files to and from PDF format without requiring an internet connection. Designed to work fully offline, this powerful tool ensures complete privacy by processing all files directly on your device, making it ideal for users who handle sensitive documents. Whether you need to convert Word to PDF, Excel to PDF, PowerPoint to PDF, images to PDF, or convert PDF to Word, Excel, JPG, or PNG, this offline PDF converter delivers high quality results with accurate formatting. The platform also supports online usage when needed, giving users flexibility while maintaining the benefits of an offline PDF converter. With a clean interface and fast conversion engine, users can easily convert documents for work, study, or business without file size limits or watermarks. Optimized for speed and compatibility, this website works across multiple devices and operating systems, making it a dependable PDF converter online alternative for secure document processing. If you are looking for a PDF converter free, a privacy focused offline PDF converter, or a simple and efficient PDF conversion tool, this website provides a complete solution for everyday document conversion needs." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Upload",
            step3: "Convert",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="PDF Converter"
          why_use={[
            {
              title: "Universal Document Conversion",
              description:
                "Our PDF converter allows you to convert Word, Excel, PowerPoint, images, and other files into PDF, a universally accepted format. Using a PDF converter online or offline ensures documents display consistently across all devices.",
            },
            {
              title: "Convert PDFs to Editable Formats",
              description:
                "With a PDF converter tool, users can easily convert PDF to Word, Excel, JPG, or PNG. This makes editing and reusing content simple without recreating documents from scratch.",
            },
            {
              title: "Offline Conversion for Data Privacy",
              description:
                "This offline PDF converter processes files directly on your device, keeping sensitive data secure. This is ideal for users who prefer not to upload documents to a PDF converter online.",
            },
            {
              title: "Time Saving and Productive",
              description:
                "This fast PDF converter free tool converts files in just a few clicks, helping professionals, students, and businesses save time and improve productivity.",
            },
            {
              title: "Preserves Original Formatting",
              description:
                "High quality PDF conversion tools maintain fonts, layouts, images, and tables during conversion. Whether converting Word to PDF or PDF to JPG, formatting remains accurate.",
            },
            {
              title: "Supports Multiple File Formats",
              description:
                "Our modern PDF converter online supports DOCX, XLSX, PPTX, JPG, PNG, and more, making it an all in one document conversion solution.",
            },
            {
              title: "Useful for Work, Study, and Business",
              description:
                "Students, professionals, and businesses rely on PDF converters to submit assignments, share reports, and manage official documents efficiently.",
            },
            {
              title: "Eliminates File Compatibility Issues",
              description:
                "Using a PDF converter free ensures files open correctly on any device or operating system, reducing compatibility problems during file sharing.",
            },
            {
              title: "Cost Effective and Easy to Use",
              description:
                "Our free PDF converter removes the need for expensive software while offering a simple interface that requires no technical expertise.",
            },
          ]}
        />
        {/* FAQ */}
        <MiscFAQ
          faq_list={[
            {
              title: "What is an online PDF converter?",
              description:
                "An online PDF converter is a web-based tool that converts PDF files into other formats or converts supported files into PDF. It helps you prepare documents for editing, sharing, printing, and storage without installing separate software."
            },
            {
              title: "How can I convert a PDF online for free?",
              description:
                "Open a PDF conversion tool, select your file, choose the desired output format, and start the conversion. Once processing is complete, download the converted file to your device."
            },
            {
              title: "Is ShivaPDF's PDF converter free to use?",
              description:
                "Visit ShivaPDF.com to check the current availability and usage limits of its PDF conversion tools. File-size limits, supported formats, and other restrictions may depend on the specific tool."
            },
            {
              title: "Which file formats can I convert using a PDF converter?",
              description:
                "Supported formats depend on the conversion tool. Common formats include PDF, JPG, JPEG, PNG, Word DOCX, and plain text. Check the available input and output formats before starting a conversion."
            },
            {
              title: "Can I convert PDF to Word online?",
              description:
                "A PDF-to-Word converter can transform a PDF document into an editable DOC or DOCX file. The final formatting depends on the original document's layout, fonts, tables, and images."
            },
            {
              title: "Can I convert Word to PDF online?",
              description:
                "A Word-to-PDF converter can turn compatible DOC and DOCX documents into PDF files. PDF format helps maintain a consistent layout across supported devices and when printing or sharing documents."
            },
            {
              title: "Can I convert PDF to JPG or PNG?",
              description:
                "Yes, if the converter supports PDF-to-image conversion, you can export PDF pages as JPG or PNG images. Depending on the tool, each page may be saved as a separate image."
            },
            {
              title: "Can I convert JPG images to PDF?",
              description:
                "A JPG-to-PDF tool lets you combine compatible JPG or JPEG images into a PDF document. Depending on the tool, you may be able to arrange images and adjust page settings before conversion."
            },
            {
              title: "Can I convert a PDF to plain text?",
              description:
                "If text extraction is supported, you can convert a PDF into a plain text file. PDFs containing selectable text usually produce better results, while scanned documents may require OCR to recognize text."
            },
            {
              title: "Can I convert scanned PDFs into editable documents?",
              description:
                "Scanned PDFs contain page images rather than directly selectable text. Converting them into editable documents may require optical character recognition (OCR), if supported by the conversion tool."
            },
            {
              title: "Will converting a PDF preserve the original formatting?",
              description:
                "Formatting preservation depends on the source PDF, target format, and conversion method. Complex layouts, tables, fonts, and images may change during conversion, so review the output before using it."
            },
            {
              title: "Will PDF conversion reduce image quality?",
              description:
                "Image quality depends on the output format, resolution, and compression settings. Choose suitable export settings to maintain readable text and clear images when converting PDF pages."
            },
            {
              title: "Can I convert multiple files at once?",
              description:
                "Batch conversion is possible when the tool supports multiple-file processing. Check the tool's interface for file selection options and any limits on the number or size of files."
            },
            {
              title: "Can I convert large PDF files online?",
              description:
                "Large PDFs may take longer to process and require additional memory. The maximum supported file size depends on the conversion tool, browser, and available device resources."
            },
            {
              title: "Can I convert PDFs without installing software?",
              description:
                "An online PDF converter works through a compatible web browser, so a separate desktop application is generally not required. You can access the tool from a supported device with an internet connection."
            },
            {
              title: "Can I convert PDFs on my mobile phone?",
              description:
                "You can use an online PDF converter on a compatible Android phone, iPhone, or tablet. Available features and performance depend on your browser, device, file size, and the conversion tool."
            },
            {
              title: "Can I convert PDF files on Windows and Mac?",
              description:
                "Yes, a browser-based PDF converter can work on compatible Windows and macOS devices. Open the website in a supported browser, select your document, and follow the conversion steps."
            },
            {
              title: "Is it safe to use an online PDF converter?",
              description:
                "Use a trusted conversion service and review its privacy policy and file-processing practices. For sensitive documents, check whether files are uploaded to a server or processed locally in your browser."
            },
            {
              title: "Does an online PDF converter upload my files?",
              description:
                "File handling depends on how the conversion tool is implemented. Some services upload documents for server-side processing, while others process files locally in the browser. Check the tool's privacy information before converting confidential files."
            },
            {
              title: "Can I convert a password-protected PDF?",
              description:
                "A password-protected PDF may require the correct password before conversion. Support depends on the document's security settings and the capabilities of the conversion tool."
            },
            {
              title: "Can I convert PDF files without creating an account?",
              description:
                "Account requirements depend on the service. Check the relevant tool page on ShivaPDF.com to confirm whether registration or sign-in is required."
            },
            {
              title: "Why is my PDF conversion taking so long?",
              description:
                "Large files, image-heavy pages, and complex document layouts can increase processing time. Try closing unnecessary browser tabs, using a supported browser, or processing fewer files at a time."
            },
            {
              title: "Why can't I download my converted file?",
              description:
                "Check that conversion has finished and your browser allows downloads. If the download fails, try again, check available storage, and confirm that the selected output format is supported."
            },
            {
              title: "Which online PDF converter should I use?",
              description:
                "Choose a PDF converter that supports your required file formats, preserves document quality, works on your device, and clearly explains its privacy practices. ShivaPDF provides PDF-related tools that you can explore on its website."
            }
          ]} />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Recommended Tools */}
        <MiscRecommendedPages />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default PDFConverterMain;
